import { migration as initial } from "./001_initial";
import { migration as quotationCustomData } from "./002_quotation_custom_data";
import { migration as customersTable } from "./003_customers_table";
import { migration as invoiceTables } from "./004_invoice_tables";
import { migration as backfillCreditNoteNumbers } from "./005_backfill_credit_note_numbers";
import { migration as resequenceSalesInvoiceNumbers } from "./006_resequence_sales_invoice_numbers";
import { migration as customerContacts } from "./007_customer_contacts";
import { migration as resequenceSalesInvoiceSinvNumbers } from "./008_resequence_sales_invoice_sinv_numbers";
import { migration as salesOrders } from "./009_sales_orders";
import { migration as ownerDiscriminatorGuards } from "./010_owner_discriminator_guards";
import { migration as salesDebitNotes } from "./011_sales_debit_notes";
import { migration as accountingInvoiceOwnerTableBackfill } from "./012_backfill_accounting_invoice_owner_tables";
import { migration as legacyInvoiceSourceTableArchive } from "./013_archive_legacy_invoice_source_tables";

export const migrations = [
  initial,
  quotationCustomData,
  customersTable,
  invoiceTables,
  backfillCreditNoteNumbers,
  resequenceSalesInvoiceNumbers,
  customerContacts,
  resequenceSalesInvoiceSinvNumbers,
  salesOrders,
  ownerDiscriminatorGuards,
  salesDebitNotes,
  accountingInvoiceOwnerTableBackfill,
  legacyInvoiceSourceTableArchive,
];
